var globalMainSwiper;
var swiperProduct;
var isLoopSet = false; // Flag to track if setLoopTrue has been called

window.setCurrentImageCount = function () {
  const activeSlide = document.querySelector(
    '#product-images-swiper .swiper-slide-active'
  );
  const divElement = activeSlide ? activeSlide.querySelector('div') : null; // select the div element within the li
  const variantElement = document.querySelector('.swiper-variant');

  if (variantElement) {
    variantElement.style.display = 'none';
  }

  let variantCount = 0;
  if (variantElement && variantElement.textContent) {
    variantCount = parseInt(variantElement.textContent);
  }

  const isVariant = divElement ? divElement.classList.length > 0 : false;

  // Check if the active slide element exists
  if (activeSlide) {
    const slideIndex = activeSlide.getAttribute('aria-label');
    const swiperSlideIndex = document.getElementById('swiper-slide-index');
    if (swiperSlideIndex) {
      swiperSlideIndex.innerHTML =
        slideIndex + `${!isVariant && variantCount > 1 ? ' (選択中商品)' : ''}`;
    }
  }
};

window.addEventListener('DOMContentLoaded', function () {
  // Use 'load' event instead of 'DOMContentLoaded'
  /**
   * MVメインスライダー
   */
  const mvElementResult =
    document.getElementsByClassName('swiper-mv').length > 0;
  if (mvElementResult) {
    globalMainSwiper = new Swiper('.swiper-mv', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      breakpoints: {
        // 768px以上の場合
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 1.75,
          spaceBetween: 12,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
  /**
   * productサムネイルスライダー
   */
  const productElementResult =
    document.getElementsByClassName('swiper-product').length > 0;
  if (productElementResult) {
    var thumbnail = new Swiper('.swiper-thumbnail', {
      slidesPerGroup: 1,
      slidesPerView: 4,
      grid: {
        rows: 1,
        fill: 'row',
      },
      spaceBetween: 8,
      breakpoints: {
        // 749px以上
        749: {
          slidesPerGroup: 1,
          slidesPerView: 4,
          grid: {
            rows: 1,
            fill: 'row',
          },
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: '.swiper-thumbnail-button-next',
        prevEl: '.swiper-thumbnail-button-prev',
      },
    });

    //商品サムネが５枚未満の場合、矢印を非表示
    if (thumbnail.slides.length < 5) {
      document.querySelector('.swiper-thumbnail-button-next').style.display =
        'none';
      document.querySelector('.swiper-thumbnail-button-prev').style.display =
        'none';
      document.querySelector(
        '.product__media-wrapper .swiper-thumbnail'
      ).style.paddingBottom = '0px';
    }

    /**
     * productメインスライダー
     */
    swiperProduct = new Swiper('.swiper-product', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      breakpoints: {
        1024: {},
        600: {},
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: thumbnail,
      },
      on: {
        slideChange: function () {
          setTimeout(() => {
            if (typeof window.setCurrentImageCount === 'function') {
              window.setCurrentImageCount();
            }
          }, 0);
        },
      },
    });
  }

  // Expose the function to set loop to true globally
  window.setLoopTrue = function () {
    if (isLoopSet) return; // Prevent multiple calls
    if (swiperProduct) {
      const oldSlidesLength = swiperProduct.slides.length; // Get total number of slides before destruction
      const currentIndex = swiperProduct.activeIndex + 1; // Store the current index

      swiperProduct.destroy(false, true);
      // Reinitialize Swiper with loop set to true
      swiperProduct = new Swiper('.swiper-product', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        breakpoints: {
          1024: {},
          600: {},
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: thumbnail,
        },
        on: {
          init: function () {
            const newSlidesLength = swiperProduct.slides.length; // Get total number of slides after reinitialization
            // If the number of slides has changed, adjust the current index
            let newIndex;
            if (newSlidesLength !== oldSlidesLength) {
              newIndex = newSlidesLength - 2; // Adjust index to the second last slide
            } else {
              newIndex = currentIndex; // Keep the same index if the number of slides hasn't changed
            }
            setTimeout(() => {
              swiperProduct.slideTo(newIndex); // Slide to the adjusted index
            }, 100); // Adding a slight delay to ensure Swiper is fully set up
          },
          slideChange: function () {
            setTimeout(() => {
              if (typeof window.setCurrentImageCount === 'function') {
                window.setCurrentImageCount();
              }
            }, 0);
          },
        },
      });
    }

    // Set the flag to true
    isLoopSet = true;
  };

  window.setInitialSlide = function () {
    if (isLoopSet) return; // Prevent multiple calls

    if (swiperProduct) {
      const oldSlidesLength = swiperProduct.slides.length; // Get total number of slides before destruction
      const currentIndex = swiperProduct.activeIndex; // Store the current index

      swiperProduct.destroy(false, true);
      // Reinitialize Swiper with loop set to true
      swiperProduct = new Swiper('.swiper-product', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        breakpoints: {
          1024: {},
          600: {},
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: thumbnail,
        },
        on: {
          init: function () {
            const newSlidesLength = swiperProduct.slides.length; // Get total number of slides after reinitialization
            // If the number of slides has changed, adjust the current index
            let newIndex;
            if (newSlidesLength !== oldSlidesLength) {
              newIndex = newSlidesLength - 2; // Adjust index to the second last slide
            } else {
              newIndex = currentIndex; // Keep the same index if the number of slides hasn't changed
            }
          },
          slideChange: function () {
            setTimeout(() => {
              if (typeof window.setCurrentImageCount === 'function') {
                window.setCurrentImageCount();
              }
            }, 0);
          },
        },
      });
    }

    // Set the flag to true
    isLoopSet = true;
  };
});
